<template>
  <el-dialog :title="info.status==2?'账户信息':'申请账户'" :visible.sync="formVisible" :close-on-click-modal="false"
    width="800px">
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small"
      label-width="130px">
      <el-form-item label="企业名称：" prop="companyName" class="width100">
        <el-input placeholder="请输入企业名称" v-model="form.companyName" :disabled="info.status==2">
        </el-input>
      </el-form-item>
      <el-form-item label="企业性质：" prop="comproperty" class="width100">
        <el-select v-model="form.comproperty" placeholder="请选择" clearable  :disabled="info.status==2">
          <!-- <el-option label="全部" value=""></el-option> -->
          <el-option label="企业" :value="1"></el-option>
          <el-option label="个体工商户" :value="2"></el-option>
          <el-option label="事业单位" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="银行名称：" prop="bankName" class="width100">
        <el-input placeholder="请输入银行名称" v-model="form.bankName"  :disabled="info.status==2">
        </el-input>
      </el-form-item>
      <el-form-item label="银行卡号：" prop="bankCard" class="width100">
        <el-input placeholder="请输入银行卡号" v-model="form.bankCard"  :disabled="info.status==2">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import sysTongshangyunApi from '@/api/sys/tongshangyun'

  function initFormBean() {
    const formBean = {
      companyName: null,
      comproperty: null,
      bankName: null,
      bankCard: null
    }
    return formBean
  }

  export default {
    props: {
      addressList: Array
    },
    data() {
      return {
        form: initFormBean(),
        formVisible: false,
        selectItems: [],
        isLoading:false,
        formRules: {
          companyName: [{
            required: true,
            message: '请输入企业名称',
            trigger: 'blur'
          }],
          comproperty: [{
            required: true,
            message: '请选择企业性质',
            trigger: 'change'
          }],
          bankName: [{
            required: true,
            message: '请输入银行名称',
            trigger: 'blur'
          }],
          bankCard: [{
            required: true,
            message: '请输入银行卡号',
            trigger: 'blur'
          }],
        },
        id: null,
        info: {}
      }
    },
    created() {

    },
    methods: {
      resetForm() {
        this.form = initFormBean()
      },
      handleCreate({
        id,
        data
      }) {
        this.resetForm()
        // console.log('row: ',id,type);
        this.id = id
        this.info = data
        if (data.status) {
          Object.keys(this.form).forEach(key => {
            this.form[key] = data[key]
          });
        }
        this.formVisible = true
        this.$nextTick(async () => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      doCreate() {
        this.$refs["dataForm"].validate((valid) => {
          if (valid) {
            this.isLoading = true
            let params = {
              ...this.form,
              userId: this.id
            }
            sysTongshangyunApi.registerCompanyMember(params).then(res => {
              // this.technicalLine = ''
              // this.customerLine = ''
              console.log('data111: ',res);
              // this.postCallback(data)
              window.open(res.data, '_blank');
              this.formVisible = false;
              this.$emit('created')
              this.isLoading=false
            }).catch(res=>{
                this.isLoading=false
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      postCallback(data) {
        this.$message.success('操作成功')
        this.formVisible = false;
        this.$emit('created')
        this.isLoading=false
      },
    }
  }
</script>
<style lang="scss" scoped>
  ::v-deep .el-select {
    width: 100%;
  }

  ::v-deep .el-cascader {
    width: 100%;
  }

  ::v-deep .el-input {
    width: 100%;
  }

  .el-form-item--small.el-form-item {
    width: 48%;
    display: inline-block;
    vertical-align: top;
  }

  .el-date-editor--datetimerange.el-input,
  .el-date-editor--datetimerange.el-input__inner {
    width: 100%;
  }

  .el-form-item--small.el-form-item.width100 {
    width: 97%;
  }
</style>
